export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12101.db3a5760.jpg";